import React from 'react';
import { ApplicationStatuses } from '../../../lib/systemVariables';
import { formatNumber } from '../../../lib/utils';
import Toggle from '../../commonComponents/util/Toggle';
import { TableViews } from '../../../lib/constants';
import GridIcon from '../../commonComponents/shared/GridIcon';

export default class ApplicationsListControls extends React.Component {

    updateStatus(status) {
        if (status !== this.props.status) {
            this.props.update("status", status);
        }
    }

    updateDays(status, event) {
        const days = {
            ...this.props.days,
            [status]: event.target.value
        };
        this.props.update("days", days);
    }

    render() {
        const isAllStatuses = !this.props.status;
        const hasStatusDateFilter = this.props.status === "Paid" || this.props.status === "Rejected";
        const activeDateFilterKey = isAllStatuses ? "Recent" : (hasStatusDateFilter ? this.props.status : null);

        return (
                <div className="container" style={{paddingTop: "20px", paddingBottom: "20px"}}>
                    <div className="application-options">
                        <p className={`application-option status-option-all ${isAllStatuses ? "active" : ""}`}
                            onClick={this.updateStatus.bind(this, null)}>
                            All
                        </p>
                        {Object.keys(ApplicationStatuses).map(statusKey => {
                            const status = ApplicationStatuses[statusKey];
                            const count = formatNumber(this.props.statusCounts[statusKey.charAt(0).toLowerCase() + statusKey.slice(1)]);
                            return (
                                <p key={statusKey}
                                    className={`application-option status-option-${statusKey.toLowerCase()} ${this.props.status === statusKey ? "active" : ""}`}
                                    onClick={this.updateStatus.bind(this, statusKey)}>
                                    {status} <span className="status-option-count">{count}</span>
                                </p>
                            );
                        })}
                        <div className="application-options-inquire-only">
                            <Toggle
                              id="inquire-only"
                              name="inquireOnly"
                              value={this.props.inquireOnly}
                              onChange={() => this.props.toggleInquireOnly()}
                            />
                            <span className="toggle-label">Show Inquire Only</span>
                        </div>
                        <div className={`application-options-date-filter ${!activeDateFilterKey ? "date-filter-disabled" : ""}`}>
                            <div className="custom-select">
                                <select
                                    disabled={!activeDateFilterKey}
                                    value={activeDateFilterKey ? this.props.days[activeDateFilterKey] : "30"}
                                    onChange={activeDateFilterKey ? this.updateDays.bind(this, activeDateFilterKey) : undefined}
                                >
                                    <option value="30">Last 30 days</option>
                                    <option value="60">Last 60 days</option>
                                    <option value="90">Last 90 days</option>
                                    <option value="">All time</option>
                                </select>
                                <i className="material-icons">arrow_drop_down</i>
                            </div>
                        </div>
                        <div className="application-details-toggle">
                            <div className="button-switch">
                                <button
                                    className={`btn btn-flat btn-small view-toggle-button ${
                                        this.props.filters.view === TableViews.Standard ? "active" : "inactive"
                                    }`}
                                    style={{ width: '44px' }}
                                    title="Standard view"
                                    aria-label="Standard view"
                                    onClick={() => this.props.toggleView(TableViews.Standard)}>
                                    <GridIcon rows={2} columns={2} gap={2} />
                                </button>
                                <button
                                    className={`btn btn-flat btn-small view-toggle-button ${
                                        this.props.filters.view === TableViews.Detailed ? "active" : "inactive"
                                    }`}
                                    style={{ width: '44px' }}
                                    title="Detailed view"
                                    aria-label="Detailed view"
                                    onClick={() => this.props.toggleView(TableViews.Detailed)}>
                                    <GridIcon rows={3} columns={3} />
                                </button>
                            </div>
                        </div>
                        {this.props.canExport && (
                            <button
                                className="btn btn-flat btn-small action-btn-export"
                                onClick={this.props.onExport}
                                disabled={this.props.exportDisabled}
                            >
                                <img
                                    src={`/images/export-icon${this.props.exportDisabled ? "-disabled" : ""}.png`}
                                    className="icon-left"
                                    alt="export-icon"
                                />
                                Export
                            </button>
                        )}
                    </div>
                </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/applicationsComponents/applications/ApplicationsListControls.jsx